import { mountRootParcel, type Parcel } from 'single-spa';
import { useContext, useEffect, useRef } from 'react';
import { UserContext } from '@adflow/utils';

export function Index() {
  const { user } = useContext(UserContext);
  const mountElementRef = useRef<HTMLDivElement | null>(null);

  // Mount manually because single-spa-react/parcel can remain unmounted after
  // React 18 StrictMode's development-only mount -> unmount -> mount cycle.
  useEffect(() => {
    const mountElement = mountElementRef.current;
    if (!mountElement) return;

    let parcel: Parcel | null = null;
    let cancelled = false;

    import('creative-hub-vue/App')
      .then((lifecycles) => {
        if (cancelled) return undefined;

        parcel = mountRootParcel(lifecycles as never, {
          domElement: mountElement,
          routerBasePath: '/',
          user,
        });

        return parcel.mountPromise;
      })
      .catch((error) => {
        if (!cancelled) {
          console.error('metrics parcel error', error);
        }
      });

    return () => {
      cancelled = true;
      const mountedParcel = parcel;
      if (mountedParcel) {
        mountedParcel.mountPromise
          .then(() =>
            mountedParcel.getStatus() === 'MOUNTED' ? mountedParcel.unmount() : undefined,
          )
          .catch(() => undefined);
      }
    };
  }, [user]);

  return (
    <div>
      <div ref={mountElementRef} data-test-id="metrics-parcel" />
    </div>
  );
}
